import React from "react";
import { observer } from "mobx-react";
import appState from "../../stores";
import { Button, Checkbox, Classes, RangeSlider } from "@blueprintjs/core";
import { SketchPicker } from "react-color";
import { Popover2, Select } from "@blueprintjs/labs";
import classnames from "classnames";
import Collapsable from "../utils/Collapsable";
import SimpleSelect from "../utils/SimpleSelect";
import mouse from "../../graph-frontend/src/select";
import * as d3Chromatic from "d3-scale-chromatic";


@observer
class EdgesPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            timeOutRef: null,
            //   sizeOptionOpen: false,
            colorOptionOpen: false,
            directionOptionOpen: false,
            //   colorOptionOpen:false,
            thicknessOptionOpen: false,
        };
    }

    render() {
        let graph = appState.graph.graph;
        return (
            <div>
                <text style={{ fontSize: "12px" }}>{`Modifying All Edges`}</text>


                {/* Collapsable Option: Color */}
                <Collapsable
                    name="Color"
                    isOpen={this.state.colorOptionOpen}
                    onToggle={() =>
                        this.setState({
                            colorOptionOpen: !this.state.colorOptionOpen
                        })
                    }
                >
                    <div className={classnames(Classes.CARD, "sub-option")}>
                        <div>
                            <p style={{ display: "inline" }}>Select Edge Color: </p>
                            <span style={{ float: "right" }}>
                                <Popover2
                                    placement="bottom"
                                    modifiers={{
                                        preventOverflow: {
                                            enabled: false,
                                        },
                                    }}>
                                    <Button
                                        text="  "
                                        style={{
                                            backgroundImage: "inherit",
                                            backgroundColor: appState.graph.edges.color
                                        }}
                                    />
                                    <SketchPicker
                                        color={appState.graph.edges.color}
                                        onChange={(it) => {
                                            appState.graph.process.graph.forEachNode(n => {

                                                let red = new THREE.Color(appState.graph.edges.color).r;
                                                let blue = new THREE.Color(appState.graph.edges.color).g;
                                                let green = new THREE.Color(appState.graph.edges.color).b;
                                                n.renderData.linecolor.r = red;
                                                n.renderData.linecolor.g = blue;
                                                n.renderData.linecolor.b = green;
                                            });
                                            (appState.graph.edges.color = it.hex);
                                            /**update edge color in real time*/
                                            appState.graph.process.onHover();
                                        }}
                                    />
                                </Popover2>
                            </span>
                        </div>

                    </div>

                    <div className={classnames(Classes.CARD, "sub-option")}>
                        <div>
                            <p style={{ display: "inline" }}>Color by Weight: </p>
                            <span style={{ float: "right" }}>
                                <label className=".pt-large">
                                    <input
                                        type="checkbox"
                                        onChange={() => {
                                            appState.graph.colorByWeight = !appState.graph.colorByWeight;
                                            console.log("Color by Weight:", appState.graph.colorByWeight);

                                            if (appState.graph.colorByWeight &&
                                                (appState.graph.maxWeight === undefined ||
                                                    appState.graph.maxWeight === null)) {
                                                const weights = appState.graph.rawGraph.edges
                                                    .map((e) => parseFloat(e?.weight))
                                                    .filter((w) => !isNaN(w));
                                                const maxWeight =
                                                    weights.length > 0 ? Math.max(...weights) : 1;
                                                appState.graph.maxWeight = maxWeight;
                                                console.log("Computed maxWeight:", maxWeight);
                                            }
                                        }}
                                    />
                                </label>
                            </span>
                        </div>
                        {appState.graph.colorByWeight && (
                            <div
                                style={{
                                    marginTop: 6,
                                    height: 16,
                                    width: "100%",
                                    borderRadius: 4,
                                    background: `linear-gradient(to right, ${[0, 0.25, 0.5, 0.75, 1]
                                        .map(t => new THREE.Color(d3Chromatic.interpolateOrRd(t)).getStyle())
                                        .join(", ")})`
                                }}
                            ></div>
                        )}
                    </div>

                    <div className={classnames(Classes.CARD, "sub-option")}>
                        <div>
                            <p style={{ display: "inline" }}>Color by Distance: </p>
                            <span style={{ float: "right" }}>
                                <label className=".pt-large">
                                    <input
                                        type="checkbox"
                                        checked={appState.graph.colorByDistance}
                                        onChange={() => {
                                            appState.graph.colorByDistance = !appState.graph.colorByDistance;
                                            appState.graph.frame.colorByDistance = !appState.graph.frame.colorByDistance;
                                            if (appState.graph.colorByDistance) {
                                                appState.graph.frame.applyEdgeColorByDistance();
                                            } else {
                                                appState.graph.frame.resetEdgeColors();
                                            }
                                        }}
                                    />
                                </label>
                            </span>
                        </div>
                        {appState.graph.colorByDistance && (
                            <div
                                style={{
                                    marginTop: 6,
                                    height: 16,
                                    width: "100%",
                                    borderRadius: 4,
                                    background: `linear-gradient(to right, ${[0, 0.25, 0.5, 0.75, 1]
                                        .map(t => new THREE.Color(d3Chromatic.interpolateViridis(t)).getStyle())
                                        .join(", ")})`
                                }}
                            ></div>
                        )}
                    </div>
                </Collapsable>

                <Collapsable
                    name="Direction"
                    isOpen={this.state.directionOptionOpen}
                    onToggle={() =>
                        this.setState({
                            directionOptionOpen: !this.state.directionOptionOpen
                        })
                    }
                >
                    <div className={classnames(Classes.CARD, "sub-option")}>
                        <div>
                            <p style={{ display: "inline" }}>Show Edge Direction: </p>
                            <span style={{ float: "right" }}>
                                <label class=".pt-large">
                                    <input
                                        type="checkbox"
                                        onChange={it => {
                                            console.log(appState.graph.directedOrNot);
                                            appState.graph.directedOrNot = !appState.graph.directedOrNot;
                                        }
                                        }
                                    />
                                </label>
                            </span>
                        </div>

                    </div>
                </Collapsable>



                {/* 
                <div>
                     <section style = {{marginTop: "15px"}}>
                         <p style={{display: "inline"}}>Show Edge Direction: </p>
                         <div style={{display: "inline", float: "right"}}>
                               <input 
                                 type="checkbox"
                                 onChange={it => {
                                     console.log(appState.graph.directedOrNot);
                                     appState.graph.directedOrNot = !appState.graph.directedOrNot;
                                 }
                                 }
                               />
                         </div>
                     </section>
                 </div> */}

                {/* <Collapsable
                    name="Thickness"
                    isOpen={this.state.thicknessOptionOpen}
                    onToggle={() =>
                        this.setState({
                            thicknessOptionOpen: !this.state.thicknessOptionOpen
                        })
                    }
                    >
                    <div className={classnames(Classes.CARD, "sub-option")}>
                        <section>
                            <p>Edge Thickness by distance: </p>
                            <span style={{float:"right"}}>
                            <label class=".pt-large">
                            <input 
                                 type="checkbox"
                                 onChange={it => {
                                     console.log(appState.graph.edgeThicknessByDistance);
                                     appState.graph.edgeThicknessByDistance = !appState.graph.edgeThicknessByDistance;
                                 }
                                 }
                               />
                            </label>
                            </span>
                        </section>
                    </div>
                </Collapsable> */}
            </div>
        );
    }
}

export default EdgesPanel;